module.exports = __webpack_public_path__ + "img/Working.44c8fae4.svg";